export default "__VITE_ASSET__Cy_OSGcK__"